"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfig = exports.ConfigProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _base = require("@site/pattern-library-utils/base.functions");
var _apiConfig = _interopRequireDefault(require("../config/api-config"));
var _functions = require("../utils/functions");
var _useConfigData = _interopRequireDefault(require("../hooks/useConfigData"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const ConfigContext = /*#__PURE__*/(0, _react.createContext)();
const QUERY_PARAM_NAMES = ['plan', 'hivemind', 'itc', 'src', 'term', 'contextState', 'cartItem', 'marketid', 'currencyid', 'itemTag', 'tekcub'];

/**
 * ConfigProvider
 *
 * @param {Object} props The component props
 * @param {ReactNode} props.children The children components
 * @param {Object} props.searchParams The search parameters
 * @param {string} props.plid Unique API Identifier
 * @param {string} props.hostname The hostname
 * @returns {ReactNode} ConfigProvider
 */
const ConfigProvider = ({
  children,
  plid,
  hostname,
  searchParams,
  paymentConfigUrl,
  asModal
}) => {
  const environment = (0, _base.getDefaultEnv)();
  const baseUrl = (0, _react.useMemo)(() => _apiConfig.default[environment]?.getLayoutUrl(hostname, plid), [environment, hostname, plid]);
  const appParams = (0, _react.useMemo)(() => (0, _functions.getAppParams)(QUERY_PARAM_NAMES, searchParams, false), [searchParams]);
  const {
    configData,
    postConfigData,
    getLoading,
    postLoading,
    error
  } = (0, _useConfigData.default)(baseUrl, appParams, null, hostname);
  const contextValue = (0, _react.useMemo)(() => ({
    configData,
    loading: getLoading,
    postLoading,
    error,
    paymentConfigUrl,
    updateInstance: postConfigData,
    asModal,
    appParams
  }), [configData, getLoading, postLoading, error, paymentConfigUrl, postConfigData, asModal, appParams]);
  return /*#__PURE__*/_react.default.createElement(ConfigContext.Provider, {
    value: contextValue
  }, children);
};
exports.ConfigProvider = ConfigProvider;
ConfigProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  plid: _propTypes.default.string,
  hostname: _propTypes.default.string.isRequired,
  searchParams: _propTypes.default.shape({
    plan: _propTypes.default.string,
    hivemind: _propTypes.default.string,
    itc: _propTypes.default.string,
    src: _propTypes.default.string,
    itemTag: _propTypes.default.string,
    term: _propTypes.default.string,
    contextState: _propTypes.default.string,
    cartItem: _propTypes.default.string,
    marketid: _propTypes.default.string,
    currencyid: _propTypes.default.string
  }),
  paymentConfigUrl: _propTypes.default.string,
  asModal: _propTypes.default.bool
};
const useConfig = () => (0, _react.useContext)(ConfigContext);
exports.useConfig = useConfig;